<mat-toolbar class="subtitulo">Conjuntos de Contas Contábeis</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">

            <div fxLayout="row" fxLayoutGap="20px" fxFlexFill style="margin-bottom: 16px;">
                <div fxFlex="50%" ngModelGroup="comboCategoriaOrigem">
                    <app-combo-generico
                            (mudancaSelecao)="onCategoriaOrigemChange($event)"
                            [placeholder]="'Conta Contábil Origem'"
                            [configuracao]="configuracaoSeletorCategoria"
                            [opcoes]="comboCategorias"
                            [valor]="idCategoriaOrigem">
                    </app-combo-generico>
                </div>
                <div fxFlex="50%" ngModelGroup="comboCategoriaDestino">
                    <app-combo-generico
                            (mudancaSelecao)="onCategoriaDestinoChange($event)"
                            [placeholder]="'Conta Contábil Destino'"
                            [configuracao]="configuracaoSeletorCategoria"
                            [opcoes]="comboCategorias"
                            [valor]="idCategoriaDestino">
                    </app-combo-generico>
                </div>
            </div>

            <div fxLayout="row" fxLayoutGap="20px" fxFlexFill style="margin-bottom: 16px;">
                <div fxFlex="50%">
                    <mat-form-field fxFlex="100%">
                        <mat-label>Ativo/Inativo</mat-label>
                        <mat-select [(ngModel)]="ativo" name="ativo" (selectionChange)="onAtivoChange($event)">
                            <mat-option value="todos">Todos</mat-option>
                            <mat-option value="ativo">Ativo</mat-option>
                            <mat-option value="inativo">Inativo</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxFlex="50%">
                    <mat-form-field fxFlex="100%">
                        <mat-label>Descrição dos Argumentos</mat-label>
                        <input matInput
                               name="descricaoArgumentos"
                               [(ngModel)]="descricaoArgumentos"
                               placeholder="Digite a descrição para buscar">
                    </mat-form-field>
                </div>
            </div>

            <div class="botoes" dir="rtl" fxFlexFill fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;">
                <button (click)="consultar()" fxFlex="20%" mat-raised-button>
                    CONSULTAR
                </button>

                <button (click)="limpar()" fxFlex="20%" mat-raised-button style="padding-right: 20px">
                    LIMPAR
                </button>
            </div>
        </form>

        <div *ngIf="perfilAcesso.insere" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 20px">
            <div>
                <button [routerLink]="['/conjuntos-categoria-contabil/cadastrar']" color="primary" mat-fab
                        matTooltip="Adicionar novo argumento" routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>

        <table *ngIf="mostrarTabela; else tabelaSemDados" [dataSource]="dataSource" mat-table style="margin-top: 20px">

            <ng-container matColumnDef="categoriaOrigem" style="width: 30%">
                <th *matHeaderCellDef mat-header-cell> Conta Contábil Origem</th>
                <td *matCellDef="let element" mat-cell> {{ resgatarDescricao(element.idCategoriaOrigem) }}</td>
            </ng-container>

            <ng-container matColumnDef="categoriaDestino" style="width: 30%">
                <th *matHeaderCellDef mat-header-cell> Conta Contábil Destino</th>
                <td *matCellDef="let element" mat-cell> {{ resgatarDescricao(element.idCategoriaDestino) }}</td>
            </ng-container>

            <ng-container matColumnDef="ativo" style="width: 10%">
                <th *matHeaderCellDef mat-header-cell> Ativo</th>
                <td *matCellDef="let element" mat-cell>
                    {{ element.ativo ? 'Ativo' : 'Inativo' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="acoes">
                <th *matHeaderCellDef mat-header-cell> Ações</th>
                <td *matCellDef="let element" mat-cell>
                    <button (click)="deletar(element)" *ngIf="perfilAcesso.deleta" mat-button>
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button (click)="atualizar(element)" *ngIf="perfilAcesso.altera" mat-button>
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button (click)="atualizar(element)" *ngIf="perfilAcesso.consulta && !perfilAcesso.altera" mat-button>
                      <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
        </table>

        <div [hidden]="!mostrarTabela">
            <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
        </div>

        <ng-template #tabelaSemDados>
            <div class="painel-consultar" style="margin-top: 20px">
                <div fxFlexFill fxLayout="row" fxLayoutAlign="center center">
                    <h3>{{ msg }}</h3>
                </div>
            </div>
        </ng-template>

    </div>
</div>
